<template>
  <div>
    <div class="mb-3">
      <div class="tab-header-option">
        <v-row class="ma-0">
        <v-col class="pa-0" :cols="12" :lg="6" :md="6" :sm="12">
          <v-col class="pa-0 tab-header-option-text">Vote Poll</v-col>
          <v-col class="pa-0 tab-subtitle-2 font-weight-thin"
            >การสร้างแบบสำรวจความคิดเห็น</v-col
          >
        </v-col>
        <v-col class="pa-0 text-right" :cols="12" :lg="6" :md="6" :sm="12">
          <v-btn
            @click="initialize"
            class="pl-5 pr-5 xs-full-width font-weight-light"
            elevation="0"
            color="#d9d9d9"
            outlined
          >
            <v-icon left>mdi-cached</v-icon>
            <span class="text-refresh">{{
              $vuetify.lang.t('$vuetify.courseManagement.filterBar.refresh')
            }}</span>
          </v-btn>
        </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col :cols="12" :lg="4" :md="4" :sm="12">
          <div class="header-option">
            <div class="tab-header-container  pt-2">
              <v-row justify="space-between" class="ma-0">
                <v-col md="6" :cols="12" class="pr-0 pl-0 pb-0 pt-2">
                  <div class="tab-header-text">Poll List</div>
                </v-col>
                <v-col md="6" :cols="12" class="pa-0">
                  <div class="tab-header-text text-right">
                    <v-btn
                      elevation="0"
                      @click="openVotePollDialog(null)"
                    >
                      <v-icon color="#308ab7">mdi-plus</v-icon>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addQuestion'
                            )
                          }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div
              class="question-list-container"
              v-for="(question, index) in arrQuestion"
              :key="question._id"
            >
              <div class="question-detail">
                <span class="question-no">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.votePoll'
                    )
                  }}
                  {{ ' ' + (limit * (page - 1) + (index + 1)) }}.
                </span>
                <span class="question-list-text">
                  {{ question.question }}
                </span>
                <div class="align-right">
                    <!-- @click="editQuestion(question.id)" -->
                  <v-btn
                    elevation="0"
                    class="ma-2 button-secondary font-weight-light text-capitalize btn-edit"
                    outlined
                    small
                    @click="editQuestion(question.id)"
                    >show</v-btn
                  >
                  <v-btn
                    elevation="0"
                    class="ma-2 text-capitalize font-weight-light button-primary btn-send"
                    :disabled="!valid"
                    small
                    @click="removeRowQuestion(question.id, question.livestreamID)"
                    >
                      remove
                    </v-btn
                  >
                </div>
                <!-- <div class="align-right">
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="0"
                    class="ma-2 button-secondary font-weight-light text-capitalize btn-edit"
                    outlined
                    small
                    @click="editQuestion(question.id)"
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.edit'
                      )
                    }}</v-btn
                  >
                  <v-btn
                    elevation="0"
                    class="ma-2 text-capitalize font-weight-light button-primary btn-send"
                    :disabled="!valid"
                    small
                    @click="showTimeQuestion(question.id, question.time)"
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.send'
                      )
                    }}</v-btn
                  >
                </div> -->
              </div>
            </div>
            <div class="question-list-container">
              <div class="question-detail">
                <v-pagination
                  v-model="page"
                  class="pagination-align-right justify-flex-end"
                  :length="pageCount"
                  @input="changePage"
                ></v-pagination>
              </div>
            </div>
          </div>
        </v-col>
        <v-col :cols="12" :lg="8" :md="8" :sm="12">
          <div class="header-option">
            <div class="tab-header-container">
              <div class="tab-header-text text-center">
                Poll Report
              </div>
            </div>
          </div>
          <v-row class="header-table-report ma-0">
            <v-col
              :cols="1"
              :lg="1"
              :md="1"
              :sm="12"
              class="text-center header-cell-table-report"
            ></v-col>
            <v-col
              :cols="2"
              :lg="2"
              :md="2"
              :sm="12"
              class="text-left header-cell-table-report"
              >ข้อที่.
            </v-col>
            <v-col
              :cols="4"
              :lg="4"
              :md="4"
              :sm="12"
              class="text-left header-cell-table-report"
              >คำถาม</v-col
            >
            <v-col
              :cols="3"
              :lg="3"
              :md="3"
              :sm="12"
              class="text-center header-cell-table-report"
              >จำนวนการตอบ(คน)</v-col
            >
          </v-row>
          <div
            v-for="(question, index) of arrQuestion"
            :key="question.id"
            :class="
              question.id == expandId
                ? 'content-table-report expand-panel-opt'
                : 'content-table-report'
            "
          >
            <v-row class="ma-0">
              <v-col
                :cols="1"
                :lg="1"
                :md="1"
                :sm="12"
                class="text-center cell-table-report"
              >
                <span class="question-no"
                  ><v-icon
                    @click="expand(question.id)"
                    v-if="question.id !== expandId"
                    color="#009bde"
                    >mdi-chevron-right</v-icon
                  >
                  <v-icon
                    @click="hide(question.id)"
                    v-if="question.id == expandId"
                    color="#009bde"
                    >mdi-chevron-down</v-icon
                  >
                </span>
                </v-col
              >
              <v-col
                :cols="2"
                :lg="2"
                :md="2"
                :sm="12"
                class="text-left cell-table-report"
              >
                <span class="question-no"
                  >Poll {{ ' ' + (limit * (page - 1) + (index + 1)) }}.
                </span></v-col>
              <v-col
                :cols="4"
                :lg="4"
                :md="4"
                :sm="12"
                class="text-left cell-table-report"
              >
                {{ question.question }}</v-col
              >
              <v-col
                :cols="3"
                :lg="3"
                :md="3"
                :sm="12"
                class="text-center cell-table-report"
              >
                {{countTotalAnswer(question)}}</v-col
              >
            </v-row>
            <div v-if="question.id == expandId">
              <v-row class="subcontent-table-report ma-0">
                <v-col
                  :cols="1"
                  :lg="1"
                  :md="1"
                  :sm="12"
                  class="text-center cell-table-report"
                ></v-col>
                <v-col
                  :cols="11"
                  class="text-left cell-table-report question-no opt-ans"
                  >ตัวเลือกคำตอบ
                </v-col>
              </v-row>
              <v-row class="subcontent-table-report ma-0">
                <v-col
                  :cols="1"
                  :lg="1"
                  :md="1"
                  :sm="12"
                  class="text-center cell-table-report"
                ></v-col>
                <v-col
                  :cols="10"
                  class="text-left cell-table-report question-no"
                >
                  <v-row
                    v-for="(choice, index) in question.choices"
                    :key="index"
                  >
                    <v-col
                      :cols="choice.image ? 1 : 12"
                      :lg="choice.image ? 1 : 12"
                      :md="choice.image ? 1 : 12"
                      :sm="12"
                      class="align-center cell-table-report pt-0"
                      ><span class="choice-table-report"
                        >{{ index + 1 }}.
                        <span v-if="choice.text">{{ choice.text }}</span></span
                      >
                    </v-col>
                    <v-col
                      :cols="choice.image ? 5 : 8"
                      :lg="choice.image ? 5 : 8"
                      :md="choice.image ? 5 : 8"
                      :sm="12"
                      class="text-center align-center cell-table-report pt-0"
                    >
                      <v-progress-linear
                        background-color="#f5f5f5"
                        color="#009bde"
                        class="align-center"
                        :value="
                          choice.percent
                            ? choice.percent
                            : 0
                        "
                        :height="6"
                      ></v-progress-linear
                    >
                    </v-col>
                    <v-col
                      :cols="2"
                      :lg="2"
                      :md="2"
                      :sm="12"
                      class="text-center align-center cell-table-report pt-0"
                      >{{
                        choice.percent
                            ? choice.percent.toFixed(2)
                            : 0
                      }}%</v-col
                    >
                    <v-col
                      :cols="2"
                      :lg="2"
                      :md="2"
                      :sm="12"
                      class="text-center align-center cell-table-report pt-0"
                    >
                      <v-btn
                        elevation="0"
                        class="ma-2 text-capitalize align-center font-weight-light button-primary btn-send"
                        small
                        >ความเห็น {{ choice.count || 0 }} คน</v-btn
                      ></v-col
                    >
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="pa-10 pt-3">
      <!-- <div v-for="(qList, index) in arrQuestion" :key="qList._id">
      </div> -->

      <v-dialog v-model="dialogAddVotePoll" scrollable max-width="900" persistent>
        <v-overlay absolute v-if="dialogLoading">
          <v-progress-circular
            indeterminate
            color="#fff0f2"
            :size="50"
          ></v-progress-circular>
        </v-overlay>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <v-card tile>
            <v-toolbar flat dark color="primary">
              <v-toolbar-title>{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.editAddPoll'
                )
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn icon dark @click="closeDialog" v-on="on">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span class="subtitle-1">{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.close'
                  )
                }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text class="pa-0">
              <v-card class="pa-5" tile elevation="0" color="grey lighten-5">
                <p class="body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.votePoll'
                    )
                  }}
                </p>
                <v-textarea
                  hide-details=""
                  v-model="questionText"
                  name="input-7-4"
                  solo
                  :disabled="editId"
                ></v-textarea>
              </v-card>

              <v-card class="pa-5" tile elevation="0">
                <v-row no-gutters align="center">
                  <v-col
                    ><p class="body-1 font-weight-medium mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.choiceType'
                        )
                      }}
                    </p></v-col
                  >
                  <v-col>
                    <v-select
                      :disabled="editId"
                      v-model="select"
                      hide-details=""
                      :items="items"
                      :prepend-icon="
                        this.select.value == 'MULTIPLE'
                          ? 'mdi-radiobox-marked'
                          : 'mdi-check-box-outline'
                      "
                      item-text="title"
                      item-value="value"
                      return-object
                      class="pa-0 ma-0"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row no-gutters align="center">
                  <v-col>
                    <p class="body-1 font-weight-medium mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.closeTime'
                        )
                      }}
                    </p>
                  </v-col>
                  <v-col
                    ><v-datetime-picker
                      :clearText="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.datepickerClear'
                        )
                      "
                      :okText="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.datepickerOk'
                        )
                      "
                      v-model="datetime"
                    >
                    </v-datetime-picker
                  ></v-col>
                </v-row>
                <v-row no-gutters align="center">
                  <v-col>
                    <p class="body-1 font-weight-medium mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.allowAddChoice'
                        )
                      }}
                    </p>
                  </v-col>
                  <v-col class="py-0">
                    <v-checkbox
                      class="mt-0"
                      v-model="allowAddChoice"
                      :label="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.allow'
                        )
                      "
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card>

              <v-card class="pa-5" tile elevation="0" color="grey lighten-5">
                <p class="body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.choice'
                    )
                  }}
                </p>
                <v-row
                  align="center"
                  v-for="(src, index) in answer"
                  :key="index + '_vote_poll_dialog'"
                  no-gutters
                  class="mb-2"
                >
                  <v-col cols="auto" class="mr-3"
                    ><v-icon>
                      {{
                        select.value == 'MULTIPLE'
                          ? 'mdi-radiobox-blank'
                          : 'mdi-checkbox-blank-outline'
                      }}
                    </v-icon></v-col
                  >
                  <v-col>
                    <v-text-field
                      v-model="answer[index].text"
                      :value="answer[index].text"
                      outlined
                      required
                      hide-details
                      :disabled="editId"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" v-if="!editId">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                          color="error"
                          class="ml-3"
                          @click="removeRow(index)"
                          :disabled="answer.length <= 1"
                        >
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.deleteChoice'
                        )
                      }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row align="center" no-gutters class="mb-2" v-if="!editId">
                  <v-col cols="auto" class="mr-3"
                    ><v-icon>
                      {{
                        select.value == 'MULTIPLE'
                          ? 'mdi-radiobox-blank'
                          : 'mdi-checkbox-blank-outline'
                      }}
                    </v-icon></v-col
                  >
                  <v-col>
                    <v-text-field
                      v-model="answerText"
                      :placeholder="
                        this.$vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.addChoice'
                        )
                      "
                      outlined
                      required
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          icon
                          @click="addRowAnswer"
                          class="ml-3"
                          :disabled="answerText == ''"
                          v-on="on"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.addChoice'
                        )
                      }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  class="title mx-2"
                  color="blue-grey"
                  outlined
                  @click="closeDialog"
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                    )
                  }}</v-btn
                >
                <v-btn
                  class="title mx-2"
                  color="primary"
                  :disabled="!validationForm()"
                  @click="validate"
                >
                  <v-icon left>mdi-check</v-icon
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.save'
                    )
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialogSwipe" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.confirmAnswerType'
            )
          }}</v-card-title>
          <v-card-text class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.msg1'
              )
            }}
            <br />{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.msg2'
              )
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              class="px-9 ma-2 title"
              large
              dark
              rounded
              outlined
              @click="cancelSwipe"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                )
              }}</v-btn
            >
            <v-btn
              color="error darken-1"
              class="px-10 ma-2 title"
              large
              dark
              rounded
              @click="resetQuestion(tempType)"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.confirm'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.confirmDelete'
            )
          }}</v-card-title>
          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.confirmDeleteInfo'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              class="px-9 ma-2 title"
              large
              dark
              rounded
              outlined
              @click="dialogDelete = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                )
              }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 title"
              large
              color="error darken-1"
              dark
              rounded
              @click="deleteQuiz(questionID, streamID)"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.confirm'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDeleteSuccess" max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.deleteSuccess'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.deleteSuccessInfo'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="closeDialog">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.done'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogUpdateSuccess" max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.saveSuccess'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.saveSuccessInfo'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="closeDialog">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.done'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDuplicateSuccess" max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.duplicateSuccess'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.duplicateSuccessInfo'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="closeDialog">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.done'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
// import { uploadImage } from "@/service/upload/upload";
import { updateChoice } from '@/service/course/exam.js';
import {
  getListQuiz,
  insertQuiz,
  updateQuiz,
  deleteQuiz
} from '@/service/course/quiz.js';
import {
  getListPoll,
  insertPoll,
  votePoll,
  deletePoll,
  updatePoll,
  insertChoice,
  deleteChoice
} from '@/service/course/poll.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import axios from 'axios';
import * as firebase from 'firebase';

export default {
  props: {
    idLive: {
      type: String
    },
    setParentLoading: {
      type: Function
    }
  },
  components: {},
  data() {
    return {
      expandId: null,
      select: {
        title: this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.votePollMultipleChoice'
        ),
        value: 'MULTIPLE'
      },
      items: [
        {
          title: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.votePollMultipleChoice'
          ),
          value: 'MULTIPLE'
        },
        {
          title: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.votePollSingleChoice'
          ),
          value: 'SINGLE'
        }
      ],
      datetime: '',
      allowAddChoice: false,

      dialogSwipe: false,
      dialogDelete: false,
      dialogDeleteSuccess: false,
      dialogUpdateSuccess: false,
      dialogAddVotePoll: false,
      dialogDuplicateSuccess: false,

      model: null,
      mins: 0,
      secs: 30,
      question_score: 1,
      imgURL: '',
      imgPreview: '',
      imgPreview1: '',
      imgPreviewChoice: [{ preview: '' }],
      imageFile: null,
      imageFileChoice: null,
      imageReady: false,
      type: 'text',
      edit: null,
      choiceCheck: '',
      choiceText: '',
      questionText: '',
      arrQuestion: [],
      answer: [],
      answerText: '',
      answerImage: '',
      answer_correct: 0,
      indexQuestion: 0,
      idLiveStream: this.idLive,
      params: {},
      paramsQuestion: {},
      questionID: '',
      streamID: '',
      editId: '',
      valid: false,
      setbool: false,
      imgBool: false,
      newQuestion: false,
      tempType: '',
      editForm: [],

      showUploadPercent: false,
      progressPercent: 0,
      imageName: '',
      imgSrc: [],
      imgFile: [],
      imgUploadId: [],

      radioType: 'text',

      // paggination
      page: 1,
      limit: 10,
      pageCount: 1,
      dialogLoading: false,
      dialogInShowMode: false,
    };
  },
  watch: {
    idLive(val) {
      if (val != null) {
        console.log(val);
        this.params = {
          idlivestream: this.idLive
        };
        this.initialize();
      }
    }
  },
  async mounted() {
    await this.initialize();
  },

  computed: {
    scoreRules: [
      v =>
        !!v > 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.scoreRules'
        )
    ],
    minuteRules: [
      v =>
        !!v >= 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.minuteRules'
        )
    ],
    secondRules: [
      v =>
        !!v >= 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.secondRules'
        )
    ]
  },
  methods: {
    countTotalAnswer(question){
      let count = 0;
      (question.choices || []).forEach(q => count += q.count);
      return `${count}`;
    },
    setLoading(flag) {
      this.dialogLoading = flag;
    },
    expand(id) {
      this.expandId = id;
    },
    hide(id) {
      this.expandId = null;
    },
    async initialize() {
      this.params = {
        idlivestream: this.idLive
      };
      console.log(this.idLive);
      await this.getQuestionList();
    },
    openVotePollDialog(id) {
      this.dialogAddVotePoll = true;
      this.type = 'text';
      this.editId = null;
      this.answerText = '';
    },
    typeChoice(type) {
      this.tempType = type;
      console.log(type);
      this.dialogSwipe = true;
    },
    closeDialog() {
      this.dialogAddVotePoll = false;
      this.dialogUpdateSuccess = false;
      this.dialogDuplicateSuccess = false;
      this.dialogDeleteSuccess = false;
      this.newQuestion = false;
      this.edit = null;
      console.log(this.newQuestion);

      this.setbool = false;
      this.questionText = '';
      this.imgPreview = '';
      this.imgPreview1 = '';
      this.imgPreviewChoice = [{ preview: '' }];
      this.imageFileChoice = null;
      this.imageReady = false;
      this.question_score = 1;
      this.mins = 0;
      this.secs = 30;
      this.answer = [];
      this.editId = '';
      this.type = 'text';

      this.imageFile = null;
      this.imgPreview = '';
      this.imageName = '';
      this.progressPercent = 0;
      this.imgBool = false;

      this.percent = [];
      this.imgSrc = [];
      this.imgFile = [];
      this.getQuestionList();

      this.$refs.form.resetValidation();
    },

    resetQuestion(type) {
      console.log(type);

      switch (type) {
        case 'text':
          this.type = 'text';
          this.percent = [];
          this.imgSrc = [];
          this.imgFile = [];
          this.question_score = 1;
          this.mins = 0;
          this.secs = 30;
          this.answer = [];
          this.dialogSwipe = false;
          break;
        case 'image':
          this.type = 'image';
          this.percent = [];
          this.imgSrc = [];
          this.imgFile = [];
          this.question_score = 1;
          this.mins = 0;
          this.secs = 30;
          this.answer = [];
          this.dialogSwipe = false;
          break;
        default:
          break;
      }
    },
    cancelSwipe() {
      switch (this.tempType) {
        case 'text':
          this.radioType = 'image';
          this.dialogSwipe = false;
          break;
        case 'image':
          this.radioType = 'text';
          this.dialogSwipe = false;
          break;
        default:
          break;
      }
    },
    choiceCheckAnswer(choice) {
      this.choiceCheck = choice;
    },
    addRowAnswer: function() {
      if (this.type == 'text') {
        // if (this.answer.length == 1) {
        // this.answer[0].push({ text: this.answerText });
        // this.answerText = "";
        // } else {
        this.answer.push({ text: this.answerText });
        this.answerText = '';
        // }
      } else {
        // if (this.answer.length == 1) {
        //   this.answer[0].push({ image: this.answerImage });
        // this.answerImage = "";
        // }else{
        this.answer.push({ image: this.answerImage });
        this.answerImage = '';
        // }
      }
      console.log(this.answer);
    },
    removeRow: function(index) {
      console.log('row' + index, this.answer.length);
      console.log(this.answer);
      console.log(this.answer_correct, index);
      // this.rows.$remove(index);
      if (this.answer.length > 1) {
        if (this.answer_correct === index) {
          this.answer_correct = 0;
        } else if (this.answer_correct > index) {
          this.answer_correct = this.answer_correct - 1;
        }
        this.answer.splice(index, 1);
      }
    },

    removeRowQuestion: function(questionID, streamID) {
      this.dialogDelete = true;
      this.questionID = questionID;
      this.streamID = streamID;
    },
    async deleteQuiz(questionID, streamID) {
      this.dialogDelete = false;
      this.dialogDeleteSuccess = true;
      this.setParentLoading(true);
      await deletePoll({
        idlivestream: streamID,
        idpoll: questionID
      });
      this.arrQuestion = [];
      this.getQuestionList();
      this.setParentLoading(false);
    },
    checkMinMins() {
      if (this.mins < 0) this.mins = 0;
      if (this.mins > 60) this.mins = 60;
    },
    checkMinSecs() {
      if (this.secs < 0) this.secs = 0;
      if (this.secs > 60) this.secs = 60;
    },
    async uploadImg(file) {
      // let status = await uploadImage("question", image);
      // return status;
      this.showUploadPercent = true;

      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/question`, formData, {
          headers: {
            ...headersWithTokenForImage()
          },
          onUploadProgress: function(progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this)
        })
        .then(
          async function(response) {
            console.log(response.data.result);

            this.imgPreview = response.data.result;
          }.bind(this)
        )
        .catch(function(e) {
          console.log('FAILURE!!', e);
        });
    },

    async uploadImgChoice(index, file) {
      let formData = new FormData();
      formData.append('fileupload', file);
      // formData.append("title", file.name);

      await axios
        .post(`${domain}/uploadfile/public/image/question`, formData, {
          headers: {
            ...headersWithTokenForImage()
          },
          onUploadProgress: function(progressEvent) {
            let progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            this.updateProgress(index, progressPercent);
          }.bind(this)
        })
        .then(
          async function(response) {
            console.log(response.data.result);

            this.answer[index].image = await response.data.result;
          }.bind(this)
        )
        .catch(function(e) {
          console.log('FAILURE!!', e);
        });
    },

    async preview(event) {
      let file = event.target.files[0];

      this.imageFile = file;
      this.imgPreview = await URL.createObjectURL(file);
      this.imageName = file.name;
      this.imgBool = true;
    },

    async previewImgChoice(event) {
      let totalFiles = event.target.files.length;
      for (var i = 0; i < totalFiles; i++) {
        let file = event.target.files[i];
        // this.imgFile.push(file);

        // this.imgSrc.push({
        //   name: file.name,
        //   src: await URL.createObjectURL(file),
        //   progressPercent: 0
        // });
        this.answer.push({
          image: await URL.createObjectURL(file),
          progressPercent: 0,
          file: file,
          fileName: file.name
        });
      }
      console.log(this.answer);
    },
    updateProgress(index, percent) {
      this.answer[index].progressPercent = percent;
    },
    async duplicateQuestion(qId, index) {
      this.setbool = true;
      this.newQuestion = false;
      this.editId = qId;
      let tempMin = null;
      let tempSec = null;

      tempMin = this.arrQuestion[index].time / 1000 / 60;
      tempSec = (this.arrQuestion[index].time / 1000) % 60;
      this.mins = parseInt(tempMin);
      this.secs = tempSec;
      this.questionText = this.arrQuestion[index].question;
      this.imgPreview = this.arrQuestion[index].imageQuestion;
      if (this.imgPreview) {
        this.imgBool = true;
        this.imageReady = true;
      }

      this.question_score = this.arrQuestion[index].score;
      this.answer = this.arrQuestion[index].choices;
      this.imageReady1 = true;
      this.answer_correct = this.arrQuestion[index].correctAnswer[0];
      this.choiceCheck = this.arrQuestion[index].correctAnswer[0];

      this.answer.forEach((value, answerIndex) => {
        if (this.answer_correct === value._id) {
          this.answer_correct = answerIndex;
        }
      });

      if (
        this.arrQuestion[index].choices[0].text == '' ||
        this.arrQuestion[index].choices[0].text == null
      ) {
        this.type = 'image';
      }
      if (
        this.arrQuestion[index].choices[0].image == '' ||
        this.arrQuestion[index].choices[0].image == null
      ) {
        this.type = 'text';
      }

      this.radioType = this.type;
      //insert
      let arrChoiceId = [];
      let choiceCorrect = [];

      // if (this.imageFile != null) {
      //   await this.uploadImg(this.imageFile);
      //   console.log("UPLOADED IMAGE:", this.imgPreview);
      // }
      // console.log(this.answer)
      // if (this.type == "image") {
      //   console.log("ANSWER", this.answer);
      //   this.answer.forEach(async (choice, index) => {
      //     if (choice._id) {
      //       console.log(choice._id);
      //     } else {
      //       console.log("image choice local : ", choice.file);
      //       await this.uploadImgChoice(index, choice.file);
      //       console.log("UPLOADED IMAGE:", choice.image);
      //     }
      //   });
      // }
      let pollAnswer = [];
      for (let i = 0; i < this.answer.length; i++) {
        pollAnswer.push({
          text: this.answer[i].text,
          image: this.answer[i].image
        });
      }

      if (arrChoiceId) {
        arrChoiceId.forEach((value, index) => {
          if (this.answer_correct === index) {
            choiceCorrect.push(value);
          }
        });
      }
      let milliSec = this.secs * 1000;
      let milliMin = this.mins * 60000;
      let timeLimited = milliMin + milliSec;

      let question = {
        livestream: this.idLive,
        question: this.questionText,
        choices: arrChoiceId,
        correct: choiceCorrect,
        score: this.question_score,
        time: timeLimited
      };
      let resultQuestion = await insertPoll({ question, choices: pollAnswer });
      if (resultQuestion) {
        this.dialogDuplicateSuccess = true;
        this.edit = null;
        this.editId = '';
        this.type = 'text';
        this.questionText = '';
        this.imgPreview = '';
        this.imgPreviewChoice = [{ preview: '' }];
        this.imageFileChoice = null;
        this.imageReady = false;
        this.imageReady1 = false;
        this.question_score = 0;
        this.mins = 0;
        this.secs = 0;
        this.answer = [];
        this.setbool = false;
        this.newQuestion = false;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        this.getQuestionList();
      }
    },
    editQuestion(qId) {
      console.log('777777777', qId)
      this.setbool = true;
      this.newQuestion = false;
      this.dialogAddVotePoll = true;
      // this.edit = index;
      this.editId = qId;
      let tempMin = null;
      let tempSec = null;
      // if (this.mins >= 0 || this.secs >= 0) {
      //   this.$refs.form.resetValidation();
      // }
      for (var i = 0; i < this.arrQuestion.length; i++) {
        if (this.editId == this.arrQuestion[i].id) {
          tempMin = this.arrQuestion[i].time / 1000 / 60;
          tempSec = (this.arrQuestion[i].time / 1000) % 60;
          this.mins = parseInt(tempMin);
          this.secs = tempSec;
          this.questionText = this.arrQuestion[i].question;
          this.imgPreview = this.arrQuestion[i].imageQuestion;
          if (this.imgPreview) {
            this.imgBool = true;
            this.imageReady = true;
          }

          this.question_score = this.arrQuestion[i].score;
          this.answer = this.arrQuestion[i].choices || [];
          this.imageReady1 = true;
          this.answer_correct = this.arrQuestion[i].correctAnswer[0];
          this.choiceCheck = this.arrQuestion[i].correctAnswer[0];

          this.answer.forEach((value, index) => {
            if (this.answer_correct === value._id) {
              this.answer_correct = index;
              console.log(this.answer_correct);
            }
          });

          if (
            this.arrQuestion[i].choices[0].text == '' ||
            this.arrQuestion[i].choices[0].text == null
          ) {
            this.type = 'image';
          }
          if (
            this.arrQuestion[i].choices[0].image == '' ||
            this.arrQuestion[i].choices[0].image == null
          ) {
            this.type = 'text';
          }
        }
      }

      console.log('get edit type : ', this.radioType);
      this.radioType = this.type;
      console.log(this.answer);
      console.log(this.imgPreview);
      console.log(this.answer_correct);
    },
    validationForm() {
      let bool = true;

      this.answer.forEach(item => {
        if (item.length < 1 || (item.text == '' && item.image == '')) {
          bool = false;
        }
      });
      if (this.mins >= 0 || this.secs >= 0) {
        this.valid = true;
      }
      return this.valid && bool;
    },
    async validate1() {
      votePoll({
        idlivestream: this.idLive,
        idpoll: this.editId,
        idchoice: ['MLWJaHKB4DLQxtPuQsNt']
      });
    },
    async validate() {
      if (this.$refs.form.validate()) {
        let arrChoiceId = [];
        let choiceCorrect = [];

        if (this.mins == 0 && this.secs == 0) {
          console.log('minute = 0 && second = 0');
          return;
        }

        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
          console.log('UPLOADED IMAGE:', this.imgPreview);
        }

        if (this.mins >= 0 || this.secs >= 0) {
          this.$refs.form.resetValidation();
        }
        let choices = [];
        for (var i = 0; i < this.answer.length; i++) {
          let tempChoice = {
            text: this.answer[i].text,
            image: this.answer[i].image
          };
          if (this.answer[i]._id) {
            tempChoice.id = this.answer[i]._id;
          }
          choices.push(this.answer[i].text);
        }

        let milliSec = this.secs * 1000;
        let milliMin = this.mins * 60000;
        let timeLimited = milliMin + milliSec;
        let question = {
          livestream: this.idLive,
          question: this.questionText,
          choices,
          time: timeLimited,
          isMultipleOption: this.select.value !== 'MULTIPLE',
          canAddMoreChoice: this.allowAddChoice,
          creator: {
            _id: this.$store.state._id,
            firstName: this.$store.state.firstName,
            lastName: this.$store.state.lastName,
            image: this.$store.state.image
          }
        };
        if (this.editId) {
          let resultQuestion = await updatePoll({
            idpoll: this.editId,
            ...question
          });
          if (resultQuestion) {
            this.dialogUpdateSuccess = true;
            this.edit = null;
            this.editId = '';
            this.type = 'text';
            this.questionText = '';
            this.imgPreview = '';
            this.imgPreviewChoice = [{ preview: '' }];
            this.imageFileChoice = null;
            this.imageReady = false;
            this.imageReady1 = false;
            this.question_score = 0;
            this.mins = 0;
            this.secs = 0;
            this.answer = [];
            this.setbool = false;
            this.$refs.form.resetValidation();
            this.getQuestionList();
          }
        } else {
          console.log(
            '🚀 ~ file: insertVotePoll.vue ~ line 1311 ~ validate ~ question',
            JSON.stringify(question)
          );
          this.setLoading(true);
          let resultQuestion = await insertPoll(question);
          this.setLoading(false);
          if (resultQuestion) {
            this.dialogUpdateSuccess = true;
            this.edit = null;
            this.editId = '';
            this.type = 'text';
            this.questionText = '';
            this.imgPreview = '';
            this.imgPreviewChoice = [{ preview: '' }];
            this.imageFileChoice = null;
            this.imageReady = false;
            this.imageReady1 = false;
            this.question_score = 0;
            this.mins = 0;
            this.secs = 0;
            this.answer = [];
            this.setbool = false;
            this.newQuestion = false;
            this.$refs.form.resetValidation();
            this.getQuestionList();
          }
        }
      } else {
        console.log('not pass');
      }
    },

    async changePage(page) {
      this.page = page;
      await this.getQuestionList();
    },

    async getQuestionList() {
      if (this.idLiveStream) {
        let result = await getListPoll({
          idlivestream: this.idLive,
          page: this.page,
          limit: this.limit
        });

        this.arrQuestion = [];
        this.pageCount = result.maxPage;
        result.data.forEach(quiz => {
          this.arrQuestion.push({
            id: quiz._id,
            livestreamID: this.idLive,
            question: quiz.question,
            choices: quiz.choices,
            correctAnswer: quiz.correct,
            imageQuestion: quiz.imageQuestion,
            score: quiz.score,
            time: quiz.time,
            divider: true
          });
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.position-radio {
  display: flex;
  align-items: center;
  justify-content: center;
}
.correct {
  color: #4caf50;
  border: 1px solid #4caf50 !important;
  .check {
    position: absolute;
    left: 5px;
    top: 13px;
    i {
      color: #4caf50;
    }
  }
  p {
    color: #4caf50;
  }
}
.list-manage {
  position: relative;
  .list-icon {
    position: absolute;
    z-index: 100;
  }
}
.btn-addimage {
  width: 200px;
}
.theme--light.v-file-input .v-file-input__text--placeholder {
  margin: 0px 19px;
}
.v-application--is-ltr .v-text-field .v-input__append-inner {
  display: none;
}
.progress {
  margin: 6px 11px 5px 0px;
}
.img-panel {
  width: 100%;
  height: 150px;
  border: 2px dashed #b9b9b9;
  background: #d5d5d5;
}
.custom-btn {
  height: 20px;
  width: 20px;
  .v-btn__content {
    i {
      font-size: 10px !important;
    }
  }
}
</style>
